import { render } from "./DupCntaList.vue?vue&type=template&id=18aa72da&ts=true"
import script from "./DupCntaList.vue?vue&type=script&lang=ts"
export * from "./DupCntaList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__